// import _ from 'lodash';
import { GET_REPORT_FAILURE, GET_REPORT_REQUEST, GET_REPORT_SUCCESS } from '../../actions/sc5Report';
// import { SC5Report } from '../../types/SC5Report';
import { BGEReport } from '../../types/BGEReport';

export interface SC5ReportEntity{
  data?: BGEReport;
  errorMessage?: string;
  status: string;
}

const initialState: SC5ReportEntity = {
  data: undefined,
  errorMessage: undefined,
  status: GET_REPORT_REQUEST,
};

export const sc5Report = (state = initialState, action: any): SC5ReportEntity => {
  switch (action.type) {
    case GET_REPORT_SUCCESS:
      return Object.assign({}, state, {
        data: {
          custRestored: action.response.custRestored,
          sc5Report: {
            areas: action.response.sc5Report.file_data.areas,
            totals: action.response.sc5Report.file_data.totals,
            updatedAt: action.response.sc5Report.updatedAt,
          },
        },
        errorMessage: undefined,
        status: action.type,
      });

    case GET_REPORT_FAILURE:
      return Object.assign({}, state, {
        data: undefined,
        errorMessage: action.message,
        status: action.type,
      });

    default:
      return state;
  }
};

export default sc5Report;
